import React, { useState, useEffect } from "react";
import {
  Checkbox,
  FormControl,
  FormControlLabel,
  MenuItem,
  Radio,
  RadioGroup,
  Typography,
  Box,
  Tooltip
} from "@material-ui/core";
import CardComponent from "./lib/CardComponent";
import { FieldArray, Form, Formik } from "formik";
import * as Yup from "yup";
import { connect } from "react-redux";
import CustomizedSelect from "../customizedSelect";
import { Input } from "../../../forms/input";
import {
  getCountriesList,
  storeNomineeDetails,
  getStatesList,
  storeApplicantParams,
  getKycDetails,
  checkKyc,
  getCitiesList as getCitiesByState,
  getRelationShipList,
  getNomineeDetails,
} from "../../../../store/actions";
import DateFnsUtils from "@date-io/date-fns";
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from "@material-ui/pickers";
import {
  mobileRegex,
  nameRegex,
  pincodeRegex,
  drivingLicenseRegex,
  passportNumberRegex,
  emailRegex,
  nomineePanRegex,
  isOnlyNumber
} from ".";
import moment from "moment";
import { useLocation } from "react-router-dom";
import { differenceInYears, format } from "date-fns";

const NomineeForm = (props) => {
  const { state } = useLocation();
  const [numNominees, setNumNominees] = useState(1);
  const [relationshipList, setRelationshipList] = useState([]);
  const [countriesList, setCountriesList] = useState([]);
  const [nominateYesOrNo, setNominateYesOrNo] = useState(false);
  const [same_as_first_appicant_address, setsame_as_first_appicant_address] =
    useState(false);
  const [soaFlag, setsoaFlag] = useState('Yes');
  const [ExistingNomineeData, setExistingNomineeData] = useState([]);
  const [selectedNominees, setSelectedNominees] = useState([]);
  const [isModified, setIsModified] = useState(false); 
  const [initialValues, setInitialValues] = useState({
    nominees: Array.from({ length: numNominees }, () => ({
      nominee: "",
      name: "",
      sharePercentage: "100",
      idType: "",
      idNumber: "",
      relation: "",
      mobileNumber: "",
      email: "",
      address: "",
      address2: "",
      address3: "",
      state: "",
      city: "",
      country: "India",
      pinCode: "",
      dob: null,
      guardianName: "",
      inCapacitation: false,
      inCapacitationAmountorPercentageCheck: 'Percentage',
      inCapacitationAmount: "",
      isMinor: false
    })),
  });
  const calculateAge = (dob) => {
    const today = new Date();
    const birthDate = new Date(dob);
    let age = today.getFullYear() - birthDate.getFullYear();
    const monthDifference = today.getMonth() - birthDate.getMonth();
    if (monthDifference < 0 || (monthDifference === 0 && today.getDate() < birthDate.getDate())) {
      age--;
    }
    return age;
  };
  useEffect(() => {
    const checkReduxStore = async () => {
      if (!props.nomineDetails || !props.nomineDetails.payload) {
        return;
      }
      const { IWishToNominate } = props.nomineDetails.payload;
      if (IWishToNominate === "Y") {
        setInitialValues({ nominees: [...props.nomineDetails.state] });
        setNominateYesOrNo(false);
      } else if (IWishToNominate === "N") {
        setInitialValues({ nominees: [] });
        setNominateYesOrNo(true);
      } else {
        setInitialValues({
          nominees: Array.from({ length: numNominees }, () => ({
            nominee: "",
            name: "",
            sharePercentage: "",
            idType: "",
            idNumber: "",
            relation: "",
            mobileNumber: "",
            email: "",
            address: "",
            address2: "",
            address3: "",
            state: "",
            city: "",
            country: "India",
            pinCode: "",
            dob: null,
            guardianName: "",
            inCapacitation: false,
            inCapacitationAmountorPercentageCheck: "Percentage",
            inCapacitationAmount: "",
            isMinor: false,
          })),
        });
        setNominateYesOrNo(false);
      }
    };
    const fetchNomineeDetails = async () => {
      const params = { pan: props.store_pan };
      try {
        const response = await props.getNomineeDetails(params);
        const nomineevaluesRaw = response.Dtinformation ? response.Dtinformation : [];
      
        const nomineevalues = nomineevaluesRaw.map((nominee) => ({
          ...nominee,
          Nom1Relation: nominee.Nom1Relation
            ? nominee.Nom1Relation.charAt(0).toUpperCase() + nominee.Nom1Relation.slice(1).toLowerCase()
            : nominee.Nom1Relation,
        }));
        setExistingNomineeData([...nomineevalues, addNewNominee]);
      } catch (error) {
        alert(error)
      }
    };

    const fetchLists = async () => {
      try {
        const [relationShipResponse, countriesList] = await Promise.all([
          props.getRelationShipList(),
          props.getCountriesList(),
        ]);

        setRelationshipList(
          relationShipResponse.Dtinformation.map(({ rm_relation }) => ({
            label: rm_relation,
            value: rm_relation,
          }))
        );
        setCountriesList(
          countriesList.Dtinformation.map(({ country_name }) => ({
            label: country_name,
            value: country_name,
          }))
        );
      } catch (error) {
        console.error("Error fetching lists:", error);
      }
    };
    fetchNomineeDetails()
    checkReduxStore();
    fetchLists();
  }, []);


  const validationSchema = Yup.object().shape({
    nominees: Yup.array().of(
      Yup.object().shape({
        name: Yup.string()
          .matches(nameRegex, "Enter valid name")
          .required("Name is mandatory"),
        sharePercentage: Yup.number()
          .required("Percentage is mandatory")
          .min(1, "Percentage must be at least 1%") 
          .max(100, "Percentage cannot exceed 100%"), 
        relation: Yup.string().required("Relationship is mandatory"),
        mobileNumber: Yup.string()
          .matches(mobileRegex, "Invalid mobile number")
          .required("Mobile Number is mandatory"),
        email: Yup.string()
          .matches(emailRegex, "Invalid Email Address")
          .required("Email is mandatory"),
        idType: Yup.string().required("ID Type is mandatory"),
        idNumber: Yup.string()
          .required("ID Number is mandatory")
          .when("idType", {
            is: "AADHAR",
            then: (schema) =>
              schema
                .matches(/^\d{4}$/, "Please enter last four digits of Aadhaar Number")
                .test(
                  "is-valid-aadhaar",
                  "Enter a valid Aadhaar number",
                  (value) => value !== "0000" 
                )
                .required("Aadhaar Number is mandatory"),
          })
          .when("idType", {
            is: "PAN",
            then: (schema) =>
              schema
                .matches(nomineePanRegex, "Enter valid PAN")
          })
          .when("idType", {
            is: "DRIVING LICENSE",
            then: (schema) =>
              schema
                .matches(drivingLicenseRegex, "Enter valid driving licence")
          })
          .when("idType", {
            is: "PASSPORT",
            then: (schema) =>
              schema
                .matches(passportNumberRegex, "Enter valid Passport Number")
          }),
          address: Yup.string().required('Address is required').test(
            'max-length',
            'Address should not exceed 40 characters (including spaces and special characters)',
            value => !!value && value.length <= 40
          ),
          address2: Yup.string().notRequired().test(
            'max-length',
            'Address should not exceed 40 characters (including spaces and special characters)',
            value => !value || value.length <= 40
          ),
          address3: Yup.string().notRequired().test(
            'max-length',
            'Address should not exceed 30 characters (including spaces and special characters)',
            value => !value || value.length <= 30
          ),
        state: Yup.string().required("State is mandatory"),
        city: Yup.string().required("City is mandatory"),
        country: Yup.string().required("Country is mandatory"),
        pinCode: Yup.string()
        .nullable()
        .notRequired(),
        dob: Yup.string().nullable().notRequired(),
        guardianName: Yup.string()
          .nullable()
          .matches(nameRegex, "Enter valid Guardian Name")
          .notRequired(),
        inCapacitationAmount: Yup.number().when('inCapacitation', {
          is: true,
          then: Yup.number()
            .when('inCapacitationAmountorPercentageCheck', {
              is: 'Percentage',
              then: Yup.number()
                .min(1, "Percentage must be at least 1%")
                .max(100, "Percentage should not exceed 100%")
                .required("Percentage is required"),
              otherwise: Yup.number()
                .min(1, "Amount must be at least 1₹")
                .max(999999999, "Amount should not exceed 999999999")
                .required("Amount is required"),
            }),
        }),
      })
    ),

  });
  const handleInCapacitationChange = (index, setFieldValue, values) => (e) => {
    const isChecked = e.target.checked;

    const updatedNominees = values.nominees.map((nominee, i) => ({
      ...nominee,
      inCapacitation: isChecked ? i === index : false,
    }));
    setFieldValue("nominees", updatedNominees);
  };
  
  const validateUniqueFields = (nominees, applicantParams) => {
    const nameSet = new Set(); 
    const panSet = new Set(); 
    const dlSet = new Set(); 
    const guardianNameSet = new Set(); 
    const trimmedApplicantName = applicantParams?.i_fname?.trim().toLowerCase();
    const applicantPanandJointHolderPans = [
      applicantParams.i_pangno,
      applicantParams.i_pangno2,
      applicantParams.i_pangno3,
    ].filter(Boolean); 
    const totalPercentage = nominees.reduce(
      (sum, nominee) => sum + (Number(nominee.sharePercentage) || 0),
      0
    );

    if (totalPercentage > 100) {
      return "Total share percentage across all nominees cannot exceed 100%.";
    }
    if (totalPercentage < 100) {
      return "Total share percentage across all nominees should be exactly 100%.";
    }

    for (const nominee of nominees) {
      const { name, idType, idNumber, guardianName, email, mobileNumber } = nominee;

      const trimmedName = name?.trim().toLowerCase();
      const trimmedId = idNumber?.trim().toUpperCase();

      const trimmedGuardianName = guardianName?.trim().toLowerCase();

      if (trimmedName && trimmedName === trimmedApplicantName) {
        return `Nominee name cannot be the same as the applicant's name: ${name}`;
      }

      if (trimmedName && nameSet.has(trimmedName)) {
        return `Duplicate nominee name found: ${name}`;
      }

      if (idType === "PAN" && trimmedId && panSet.has(trimmedId)) {
        return `Duplicate PAN found: ${trimmedId}`;
      }

      if (idType === "DRIVING LICENSE" && trimmedId && dlSet.has(trimmedId)) {
        return `Duplicate Driving License found: ${trimmedId}`;
      }

      if (trimmedName && trimmedGuardianName && trimmedName === trimmedGuardianName) {
        return `Nominee name and Guardian name cannot be the same: ${name}`;
      }
 
      if (trimmedGuardianName) {
        if (trimmedGuardianName === trimmedName) {
          return `Guardian name cannot be the same as the nominee's name: ${trimmedGuardianName}`;
        }

        if (guardianNameSet.has(trimmedGuardianName)) {
          return `Duplicate Guardian name found: ${trimmedGuardianName}`;
        }

        guardianNameSet.add(trimmedGuardianName);
      }

      if (idType === "PAN" && trimmedId) {
        const allPansExcludingCurrent = new Set([
          ...applicantPanandJointHolderPans.map((pan) => pan.trim().toUpperCase()),
          ...nominees
            .filter((n) => n !== nominee && n.idType === "PAN" && n.idNumber)
            .map((n) => n.idNumber.trim().toUpperCase()),
        ]);


        if (allPansExcludingCurrent.has(trimmedId)) {
          return `Nominee PAN (${trimmedId}) cannot be the same as guardian PAN, applicant PAN, joint holder PAN, or other nominee PANs.`;
        }
      }
      if (trimmedName) nameSet.add(trimmedName);
      if (idType === "PAN" && trimmedId) panSet.add(trimmedId);
      if (idType === "DRIVING LICENSE" && trimmedId) dlSet.add(trimmedId);
    }

    return null;
  };


  const handleSubmit = (values) => {
    if (props.applicantparams.i_genMOH === "4" && !isModified) {
      Proceed();
      return;
    }
   
    const totalPercentage = values.nominees.reduce((sum, nominee) => sum + (Number(nominee.sharePercentage) || 0), 0);
    if (totalPercentage > 100) {
      alert("Total sharePercentage across all nominees cannot exceed 100%.");
      return;
    }
    if (totalPercentage < 100) {
      alert("Total sharePercentage across should be 100%.");
      return;
    }
    const validationError = validateUniqueFields(values.nominees, props.applicantparams);
    if (validationError) return alert(validationError);
    const incapacitatedNominee = values.nominees.find(n => n.inCapacitation);
    const index = incapacitatedNominee ? values.nominees.indexOf(incapacitatedNominee) + 1 : null;
    const payload = {
      Nom_IncapacitationFlag: incapacitatedNominee ? "Y" : "N",
      Nom_Incapacitation_Nominee: index ? `Nom${index}` : "",
      Nom_IncapacitationThreshold_Percent: incapacitatedNominee?.inCapacitationAmountorPercentageCheck === "Percentage"
        ? incapacitatedNominee.inCapacitationAmount
        : "",
      Nom_IncapacitationThreshold_Aum: incapacitatedNominee?.inCapacitationAmountorPercentageCheck !== "Percentage"
        ? incapacitatedNominee?.inCapacitationAmount
        : "",
    };
    const submitNomineeDetails = {};
    values.nominees.forEach((nominee, index) => {
  const i = index + 1;
  const isPinCodeValid = isOnlyNumber(nominee.pinCode);
  const updatedPinCode = isPinCodeValid ? Number(nominee.pinCode) : "";
  const updatedAddress3 = !isPinCodeValid
    ? `${nominee.address3 || ""} ${nominee.pinCode}`.trim()
    : nominee.address3;

  payload[`Nom${i}_Name`] = nominee.name || "";
  payload[`Nom${i}_Ratio`] = nominee.sharePercentage || "";
  payload[`Nom${i}_Relationship`] = nominee.relation || "";
  payload[`Nom${i}_Mobile`] = nominee.mobileNumber || "";
  payload[`Nom${i}_Email`] = nominee.email || "";
  payload[`Nom${i}_IdentityType`] = nominee.idType || "";
  payload[`Nom${i}_IDNumber`] =
    nominee.idType === "AADHAR"
      ? `XXXXXXXXXXXX${nominee.idNumber}`
      : nominee.idNumber || "";
  payload[`Nom${i}_Add1`] = nominee.address || "";
  payload[`Nom${i}_Add2`] = nominee.address2 || "";
  payload[`Nom${i}_Add3`] = updatedAddress3 || "";
  payload[`Nom${i}_City`] = nominee.city || "";
  payload[`Nom${i}_State`] = nominee.state || "";
  payload[`Nom${i}_Country`] = nominee.country || "";
  payload[`Nom${i}_Pincode`] = updatedPinCode;
  payload[`Nom${i}_DOB`] = nominee.dob || "";
  payload[`Nom${i}_Guardian`] = nominee.guardianName || "";
});

    values.nominees.forEach((nominee, index) => {
      const i = index + 1;
      const isFirst = i === 1;
      const suffix = isFirst ? "" : i;

      submitNomineeDetails[`i_nominee${suffix}`] = nominee.name || "";
      submitNomineeDetails[`i_NomRelation${suffix}`] = nominee.relation || "";
      submitNomineeDetails[`i_NomDOB${suffix}`] = nominee.dob || "";
      submitNomineeDetails[`i_Nominee${i}percentage`] =
        nominee.sharePercentage != null
          ? nominee.sharePercentage
          : values.nominees.length === 1
            ? "100"
            : values.nominees.length === 2
              ? "50"
              : values.nominees.length === 3
                ? i === 1
                  ? "33"
                  : i === 2
                    ? "33"
                    : "34"
                : "";

      submitNomineeDetails[`nom${i}email`] = nominee.email || "";
      submitNomineeDetails[`i_nomadd${isFirst ? "" : i}1`] = nominee.address || "";
      submitNomineeDetails[`i_nom${isFirst ? "" : i}country`] = nominee.country || "";
      submitNomineeDetails[`i_nomstate${suffix}`] = nominee.state || "";
      submitNomineeDetails[`i_nomcity${suffix}`] = nominee.city || "";
      submitNomineeDetails[`i_nompin${suffix}`] = nominee.pinCode || "";
      submitNomineeDetails[`i_nomguardianname${i}`] = nominee.guardianName || "";

    });
  const nomineePayload = {
    ...payload,
    Nom_SOAFlag: soaFlag === "Yes" ? "Y" : "N",
    Entby: props.userId,
    Nom_Fund: "189",
    Invpan: props.applicantparams.i_pangno,
    Nom_Folio: '',
    IWishToNominate: "Y"
  }
  const updatedNominees = values.nominees.map((nominee, index) => {
    const isPinCodeValid = isOnlyNumber(nominee.pinCode);
    const updatedAddress3 = !isPinCodeValid
      ? `${nominee.address3 || ""} ${nominee.pinCode}`.trim()
      : nominee.address3;
  
    return {
      ...nominee,
      nomType: `NOM${index + 1}`,
      pinCode: isPinCodeValid ? Number(nominee.pinCode) : "",
      sharePercentage: Number(nominee.sharePercentage),
      idType: normalizeIdType(nominee.idType),
      Add2: nominee.address2,
      Add3: updatedAddress3,
    };
  });

  props.storeNomineeDetails({
    payload: { ...nomineePayload },
    dotnetApiSubmitKeys: { ...submitNomineeDetails },
    state: values.nominees,
  })
  props.history.replace(
    "/new-investor-transaction/bank-details", state
  )
};
const Proceed = () => {
  props.storeNomineeDetails({
    payload:
      { IWishToNominate: "N" },
  })
  props.history.replace(
    "/new-investor-transaction/bank-details", state
  )
}
const handleNominees = () => {
  setNominateYesOrNo((prev) => !prev);

    if (!nominateYesOrNo) {
      setInitialValues({ nominees: [] });
    } else {
      setInitialValues({
        nominees: Array.from({ length: numNominees }, () => ({
          nominee: "",
          name: "",
          sharePercentage: "",
          idType: "",
          idNumber: "",
          relation: "",
          mobileNumber: "",
          email: "",
          address: "",
          address2: "",
          address3: "",
          state: "",
          city: "",
          country: "India",
          pinCode: "",
          dob: null,
          guardianName: "",
          inCapacitation: false,
          inCapacitationAmountorPercentageCheck: "Percentage",
          inCapacitationAmount: "",
          isMinor: false,
        })),
      });
    }
  };
  const handleAddress = (e, setFieldValue, values) => {
    const isChecked = e.target.checked;
    const addressFields = ["address", "city", "state", "country", "pinCode"];
    values.nominees.forEach((_, index) => {
      addressFields.forEach((field) => {
        const sourceValue = isChecked ? props.address?.[field.toLowerCase()] ?? "" : "";
        setFieldValue(`nominees[${index}].${field}`, sourceValue);
      });
    });
    setsame_as_first_appicant_address(isChecked);
  };
  const handleNomineeSelection = (index, value, setFieldValue) => {
    const selectedNominee = ExistingNomineeData.find((ele) => ele.Nom1 === value);
    const fields = {
      nominee: value,
      name: selectedNominee?.Nom1 === "ADD New Nominee" ? "" : selectedNominee?.Nom1 || "",
      sharePercentage: numNominees===3 ? (index===0?"34":"33") : numNominees===2?"50" : selectedNominee?.NomPer1 || "",
      email: selectedNominee?.Nom1_Email || "",
      mobileNumber: selectedNominee?.Nom1_Mobile || "",
      idType: selectedNominee?.Nom1_IdentityType || "",
      idNumber: selectedNominee?.Nom1_IDNumber || "",
      relation: selectedNominee?.Nom1Relation || "",
      address: `${selectedNominee?.Nom1_Add1 || ""} ${selectedNominee?.Nom1_Add2 || ""} ${selectedNominee?.Nom1_Add3 || ""}`.trim(),
      city: selectedNominee?.Nom1_City || "",
      state: selectedNominee?.Nom1_state || "",
      pinCode: selectedNominee?.Nom1_pin || "",
      country: selectedNominee?.Nom1_Country || "",
      guardianName: selectedNominee?.Nom1_GuardianName || "",
    };
    Object.keys(fields).forEach((key) => setFieldValue(`nominees[${index}].${key}`, fields[key]));
    setSelectedNominees((prev) => {
      const updatedSelections = [...prev];
      const previousNominee = updatedSelections[index];
      if (previousNominee && previousNominee !== "ADD New Nominee") {
        updatedSelections.splice(updatedSelections.indexOf(previousNominee), 1);
      }
      updatedSelections[index] = value;
      return updatedSelections;
    });
  };
  const handleFieldChange = (setterFn, fieldPath, value) => {
    if (!isModified) {
      setIsModified(true);
    }
    setterFn(fieldPath, value);
  };
  const getFilteredNominees = (currentIndex) => {
    const filtered = ExistingNomineeData.filter(
      (ele) =>
        ele.Nom1 === "ADD New Nominee" ||
        !selectedNominees.includes(ele.Nom1) ||
        selectedNominees[currentIndex] === ele.Nom1
    );

    return filtered.sort((a, b) => {
      if (a.Nom1 === "ADD New Nominee") return 1;
      if (b.Nom1 === "ADD New Nominee") return -1;
      return 0;
    });
  };

  return (
    <>
      {props.store_pan.charAt(3) !== "H" &&
        props.applicantparams.typeofinvestor !== "M" ? (
        <CardComponent title="Nominee Details">
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              flexWrap: "wrap",
              marginBottom: "20px"
            }}
          >
            <div style={{ flexBasis: "100%", display: "flex", justifyContent: "flex-end" }}>
              <div className="container-margin-nominee" style={{ display: "flex", alignItems: "center" }}>
                <Checkbox onChange={handleNominees} checked={nominateYesOrNo} />
                <span>I Wish not to nominate</span>
              </div>
            </div>

            {!nominateYesOrNo && (
              <Box
                sx={{
                  padding: "16px 10px 5px 10px",
                  mb: 1,
                  border: '1px dashed silver',
                  borderRadius: '8px',
                  mt: 1,
                  maxWidth: "auto",
                  width: '100%',
                }}
              >
                <Typography variant="body1" sx={{ mb: 1 }}>
                  I / We want the details of my / our nominee to be printed in the statement of holding or statement of account, provided to me/us by the AMC/DP as follows; (please tick, as appropriate):
                </Typography>
                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                  <Typography variant="subtitle1" sx={{ fontWeight: 500, mr: 2 }}>
                    Display of nominees:
                  </Typography>
                  <RadioGroup
                    row
                    value={soaFlag}
                    onChange={(e) => setsoaFlag(e.target.value)}
                    style={{ padding: "10px 0px 0px 10px" }}
                  >
                    {[
                      { label: 'Yes', value: 'Yes' },
                      { label: 'No', value: 'No' },
                    ].map((option) => (
                      <FormControlLabel
                        key={option.value}
                        value={option.value}
                        control={<Radio sx={{ color: '#007ac8' }} />}
                        label={option.label}
                        sx={{ mr: 4 }}
                      />
                    ))}
                  </RadioGroup>
                </Box>
              </Box>
            )}
          </div>
          {!nominateYesOrNo && (
            <div>

              <div>
                <Formik
                  initialValues={initialValues}
                  validationSchema={props.applicantparams.i_genMOH === "4" && !isModified ? null : validationSchema} 
                  onSubmit={handleSubmit}
                  validateOnChange={true}
                  validateOnBlur={true}
                  enableReinitialize
                >
                  {({ values, errors, touched, handleChange, setFieldValue, handleBlur, validateField }) => (
                    <Form>
                      <div style={{ display: "flex", justifyContent: "center" }}>
                        <CustomizedSelect
                          name="Number of Nominees"
                          value={numNominees}
                          nomineeStyle={true}
                          handleChange={(e) => {
                            const newNumNominees = Number(e.target.value);
                            setNumNominees(newNumNominees);
                          
                            let sharePercentages = [];
                            if (newNumNominees === 1) {
                              sharePercentages = [100];
                            } else if (newNumNominees === 2) {
                              sharePercentages = [50, 50];
                            } else if (newNumNominees === 3) {
                              sharePercentages = [34, 33, 33];
                            }
                          
                            const updatedNominees = values.nominees
                              .slice(0, newNumNominees)
                              .concat(
                                Array(Math.max(newNumNominees - values.nominees.length, 0)).fill({
                                  nominee: "",
                                  name: "",
                                  sharePercentage: "",
                                  idType: "",
                                  idNumber: "",
                                  relation: "",
                                  mobileNumber: "",
                                  email: "",
                                  address: "",
                                  address2: "",
                                  address3: "",
                                  state: "",
                                  city: "",
                                  country: "India",
                                  pinCode: "",
                                  dob: null,
                                  guardianName: "",
                                  inCapacitation: false,
                                  inCapacitationAmountorPercentageCheck: 'Percentage',
                                  inCapacitationAmount: "",
                                  isMinor: false,
                                })
                              )
                              .map((nominee, index) => ({
                                ...nominee,
                                sharePercentage: sharePercentages[index] ?? nominee.sharePercentage,
                              }));
                          
                            if (same_as_first_appicant_address) {
                              const { address, city, state, country, pinCode } = props.address || {};
                              updatedNominees.forEach((nominee, index) => {
                                updatedNominees[index] = {
                                  ...nominee,
                                  address: address ?? "",
                                  city: city ?? "",
                                  state: state ?? "",
                                  country: country ?? "India",
                                  pinCode: pinCode ?? "",
                                };
                              });
                            }
                            setFieldValue("nominees", updatedNominees);
                          }}
                          
                        >
                          {[...Array(3).keys()].map((num) => (
                            <MenuItem key={num + 1} value={num + 1}>
                              {num + 1}
                            </MenuItem>
                          ))}
                        </CustomizedSelect>
                        {!nominateYesOrNo && props.address && (() => {
                          const { state, city, address, country, pincode } = props.address;
                          const shouldShowAddressCheckbox =
                            !!state || !!city || !!address || !!country || !!pincode;

                          return shouldShowAddressCheckbox ? (
                            <div className="container-margin-nominee">
                              <Checkbox
                                checked={same_as_first_appicant_address}
                                onChange={(e) => handleAddress(e, setFieldValue, values)}
                              />
                              <span> Same as First Applicant Address</span>
                            </div>
                          ) : null;
                        })()}
                      </div>
                      <FieldArray name="nominees">
                        {() =>
                          values.nominees.map((nominee, index) => (
                            <div
                              key={index}
                              style={{
                                margin: "1rem",
                                padding: "15px 10px",
                                border: "2px solid rgb(229, 242, 249)",
                              }}
                            >
                              <div className="input-nominee-name">Nominee {index + 1} :</div>
                              <div
                                style={{
                                  display: "grid",
                                  gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))",
                                  gap: "1rem",
                                  padding: "1rem",
                                }}
                              >
                                <CustomizedSelect
                                  id={`nominees[${index}].nominee`}
                                  name="Nominee List"
                                  placeholder="Select Nominee"
                                  value={nominee.nominee}
                                  handleChange={(e) => handleNomineeSelection(index, e.target.value, setFieldValue)}
                                >
                                  {getFilteredNominees(index).map((ele) => (
                                    <MenuItem key={ele.Nom1} value={ele.Nom1} style={ele.Nom1 === "ADD New Nominee" ? { fontWeight: "bold" } : {}}>
                                      {ele.Nom1}
                                    </MenuItem>
                                  ))}
                                </CustomizedSelect>
                                <Input
                                  id={`nominees[${index}].name`}
                                  name="Name*"
                                  placeholder="Enter Name"
                                  value={nominee.name}
                                  onChange={(e) =>
                                    handleFieldChange(setFieldValue, `nominees[${index}].name`, e.target.value)
                                  }
                                  onBlur={handleBlur}
                                  isShowError={touched.nominees?.[index]?.name && !!errors.nominees?.[index]?.name}
                                  errorMessage={errors.nominees?.[index]?.name}
                                />
                                <Input
                                  id={`nominees[${index}].sharePercentage`}
                                  name="Percentage"
                                  placeholder="Enter Percentage"
                                  type="number"
                                  value={nominee.sharePercentage}
                                  onChange={(e) => {
                                    const value = e.target.value;

                                    if (value.includes('.') || value.includes(',')) return;

                                    if (value === "") {
                                      setFieldValue(`nominees[${index}].sharePercentage`, "");
                                      return;
                                    }

                                    const numericValue = parseInt(value, 10);
                                    if (!isNaN(numericValue)) {
                                      const cappedValue = numericValue > 100 ? 100 : numericValue;
                                      setFieldValue(`nominees[${index}].sharePercentage`, cappedValue);
                                      validateField(`nominees[${index}].sharePercentage`);
                                    }
                                  }}
                                  onKeyDown={(e) => {
                                    if (e.key === '.' || e.key === ',' || e.key === 'e') {
                                      e.preventDefault();
                                    }
                                  }}
                                  onBlur={handleBlur}
                                  required
                                  inputProps={{
                                    inputMode: 'numeric',  
                                    pattern: '[0-9]*',  
                                  }}
                                  isShowError={
                                    touched.nominees?.[index]?.sharePercentage &&
                                    !!errors.nominees?.[index]?.sharePercentage
                                  }
                                  errorMessage={errors.nominees?.[index]?.sharePercentage}
                                />


                                <CustomizedSelect
                                  id={`nominees[${index}].relation`}
                                  name="Relationship*"
                                  required
                                  placeholder="Select Relationship"
                                  value={nominee.relation}
                                  handleChange={(e) =>
                                    handleFieldChange(setFieldValue, `nominees[${index}].relation`, e.target.value)
                                  }
                                  onBlur={handleBlur}
                                  isError={touched.nominees?.[index]?.relation && !!errors.nominees?.[index]?.relation}
                                  errorMessage={errors.nominees?.[index]?.relation}
                                >
                                  {relationshipList.map((relation) => (
                                    <MenuItem key={relation.value} value={relation.value}>
                                      {relation.label}
                                    </MenuItem>
                                  ))}
                                </CustomizedSelect>
                                <Input
                                  id={`nominees[${index}].mobileNumber`}
                                  type="number"
                                  name="Mobile Number*"
                                  placeholder="Enter Mobile Number"
                                  value={nominee.mobileNumber}
                                  onChange={(e) =>
                                    handleFieldChange(setFieldValue, `nominees[${index}].mobileNumber`, e.target.value)
                                  }
                                  onBlur={handleBlur}
                                  required
                                  isShowError={touched.nominees?.[index]?.mobileNumber && !!errors.nominees?.[index]?.mobileNumber}
                                  errorMessage={errors.nominees?.[index]?.mobileNumber}
                                />
                                <Input
                                  id={`nominees[${index}].email`}
                                  name="Email*"
                                  placeholder="Enter Email"
                                  type="email"
                                  value={nominee.email}
                                  onChange={(e) =>
                                    handleFieldChange(setFieldValue, `nominees[${index}].email`, e.target.value)
                                  }
                                  onBlur={handleBlur}
                                  required
                                  isShowError={touched.nominees?.[index]?.email && !!errors.nominees?.[index]?.email}
                                  errorMessage={errors.nominees?.[index]?.email}
                                />
                                <CustomizedSelect
                                  id={`nominees[${index}].idType`}
                                  name="ID Type*"
                                  required
                                  placeholder="Select ID Type"
                                  value={nominee.idType}
                                  handleChange={(e) => {
                                    setFieldValue(`nominees[${index}].idType`, e.target.value);
                                    setFieldValue(`nominees[${index}].idNumber`, "");
                                    validateField(`nominees[${index}].idType`);
                                  }}
                                  isError={touched.nominees?.[index]?.idType && !!errors.nominees?.[index]?.idType}
                                  errorMessage={errors.nominees?.[index]?.idType}
                                >
                                  <MenuItem value="PAN">PAN</MenuItem>
                                  <MenuItem value="AADHAR">Aadhaar</MenuItem>
                                  <MenuItem value="DRIVING LICENSE">Driving Licence</MenuItem>
                                  <MenuItem value="PASSPORT">Passport Number</MenuItem>
                                </CustomizedSelect>
                                {nominee.idType && (
                                  <div style={{ gridColumn: "1 / -2" }}>
                                    <Input
                                      id={`nominees[${index}].idNumber`}
                                      name="ID Number"
                                      placeholder={`Enter ${nominee.idType} Number`}
                                      value={nominee.idNumber}
                                      onChange={(e) => {
                                        let value = e.target.value;
                                        if (nominee.idType === "AADHAR") {
                                          value = value.replace(/\D/g, "").slice(0, 4);
                                        } else if (nominee.idType === "PAN") {
                                          value = value.replace(/[^A-Za-z0-9]/g, "").slice(0, 10);
                                        } else if (nominee.idType === "DRIVING LICENSE") {
                                          value = value.replace(/[^A-Za-z0-9]/g, "").slice(0, 20);
                                        } else if (nominee.idType === "PASSPORT") {
                                          value = value.replace(/[^A-Za-z0-9]/g, "").slice(0, 20);
                                        }
                                        value = value.toUpperCase();
                                        handleChange({
                                          target: {
                                            name: `nominees[${index}].idNumber`,
                                            value: value.toUpperCase(),
                                          },
                                        });
                                        validateField(`nominees[${index}].idNumber`);
                                      }}
                                      onBlur={handleBlur}
                                      required
                                      isShowError={touched.nominees?.[index]?.idNumber && !!errors.nominees?.[index]?.idNumber}
                                      errorMessage={errors.nominees?.[index]?.idNumber}
                                    />
                                    {nominee.idType === "AADHAR" && (
                                      <p style={{ fontSize: "12px", color: "gray", marginTop: "4px" }}>
                                        Note: Please enter the last four digits of Aadhaar number.
                                      </p>
                                    )}
                                  </div>
                                )}
                                <Input
                                  id={`nominees[${index}].address`}
                                  name="Address 1 *"
                                  placeholder="Enter Address"
                                  value={nominee.address}
                                  onChange={(e) =>
                                    handleFieldChange(setFieldValue, `nominees[${index}].address`, e.target.value)
                                  }
                                  onBlur={handleBlur}
                                  required
                                  isShowError={touched.nominees?.[index]?.address && !!errors.nominees?.[index]?.address}
                                  errorMessage={errors.nominees?.[index]?.address}
                                />
                                <Input
                                  id={`nominees[${index}].address2`}
                                  name="Address 2"
                                  placeholder="Enter Address 2"
                                  value={nominee.address2}
                                  onChange={(e) =>
                                    handleFieldChange(setFieldValue, `nominees[${index}].address2`, e.target.value)
                                  }
                                  onBlur={handleBlur}
                                  required={false}
                                  isShowError={touched.nominees?.[index]?.address2 && !!errors.nominees?.[index]?.address2}
                                  errorMessage={errors.nominees?.[index]?.address2}
                                />
                                 <Input
                                  id={`nominees[${index}].address3`}
                                  name="Address 3"
                                  placeholder="Enter Address 3"
                                  value={nominee.address3}
                                  onChange={(e) =>
                                    handleFieldChange(setFieldValue, `nominees[${index}].address3`, e.target.value)
                                  }
                                  onBlur={handleBlur}
                                  required={false}
                                  isShowError={touched.nominees?.[index]?.address3 && !!errors.nominees?.[index]?.address3}
                                  errorMessage={errors.nominees?.[index]?.address3}
                                />

                                <Input
                                  id={`nominees[${index}].city`}
                                  name="City*"
                                  placeholder="Enter City"
                                  value={nominee.city}
                                  onChange={(e) =>
                                    handleFieldChange(setFieldValue, `nominees[${index}].city`, e.target.value)
                                  }
                                  onBlur={handleBlur}
                                  required
                                  isShowError={touched.nominees?.[index]?.city && !!errors.nominees?.[index]?.city}
                                  errorMessage={errors.nominees?.[index]?.city}
                                />
                                <Input
                                  id={`nominees[${index}].state`}
                                  name="State"
                                  placeholder="Enter State"
                                  value={nominee.state}
                                  onChange={(e) =>
                                    handleFieldChange(setFieldValue, `nominees[${index}].state`, e.target.value)
                                  }
                                  onBlur={handleBlur}
                                  required
                                  isShowError={touched.nominees?.[index]?.state && !!errors.nominees?.[index]?.state}
                                  errorMessage={errors.nominees?.[index]?.state}
                                />
                                <CustomizedSelect
                                  id={`nominees[${index}].country`}
                                  name="Country*"
                                  required
                                  placeholder="Select Country"
                                  value={nominee.country}
                                  handleChange={(e) => {
                                    setFieldValue(`nominees[${index}].country`, e.target.value);
                                    validateField(`nominees[${index}].country`);
                                  }}
                                  isError={touched.nominees?.[index]?.country && !!errors.nominees?.[index]?.country}
                                  errorMessage={errors.nominees?.[index]?.country}
                                >
                                  {countriesList.map((relation) => (
                                    <MenuItem key={relation.value} value={relation.value}>
                                      {relation.label}
                                    </MenuItem>
                                  ))}
                                </CustomizedSelect>

                                <Input
                                  id={`nominees[${index}].pinCode`}
                                  name="Pincode"
                                  placeholder="Enter Pincode"
                                  value={nominee.pinCode}
                                  onChange={(e) =>
                                    handleFieldChange(setFieldValue, `nominees[${index}].pinCode`, e.target.value)
                                  }
                                  onBlur={handleBlur}
                                  required={false}
                                />
                                <div>
                                  <div className="input-name">Date of Birth</div>
                                  <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                    <KeyboardDatePicker
                                      id={`nominees[${index}].dob`}
                                      required
                                      helperText=""
                                      className="selects"
                                      style={{ width: "100%" }}
                                      onChange={(date) => {
                                        const value = format(new Date(date), "MM/dd/yyyy");
                                        setFieldValue(`nominees[${index}].dob`, value);
                                        const age = calculateAge(date);
                                        setFieldValue(`nominees[${index}].isMinor`, age < 18);
                                        setFieldValue(`nominees[${index}].guardianName`, "");
                                      }}
                                      onBlur={handleBlur}
                                      format="dd/MM/yyyy"
                                      value={nominee.dob || null}
                                      minDate={new Date(new Date().setFullYear(new Date().getFullYear() - 100))}
                                      maxDate={new Date()}
                                      InputProps={{ readOnly: true }}
                                    />
                                  </MuiPickersUtilsProvider>
                                </div>

                                {nominee.dob && calculateAge(nominee.dob) < 18 && (
                                  <>
                                    <Input
                                      id={`nominees[${index}].guardianName`}
                                      name="Guardian Name"
                                      placeholder="Enter Guardian Name"
                                      value={nominee.guardianName || ""}
                                      onChange={(e) => {
                                        setFieldValue(`nominees[${index}].guardianName`, e.target.value);
                                      }}
                                      onBlur={handleBlur}
                                      isError={touched.nominees?.[index]?.guardianName && !!errors.nominees?.[index]?.guardianName}
                                      errorMessage={errors.nominees?.[index]?.guardianName}
                                    />
                                  </>
                                )}
                                {calculateAge(nominee.dob) > 18 && (
                                  <div
                                    style={{
                                      display: "flex",
                                      flexDirection: "column",
                                      marginTop: "1rem",
                                    }}
                                  >
                                    <div style={{ display: "flex", alignItems: "center" }}>
                                      <Tooltip
                                        title={
                                          values.nominees.some((n, i) => n.inCapacitation && i !== index)
                                            ? "Incapacitation has already been selected for another nominee. Please deselect it there to make changes."
                                            : ""
                                        }
                                        arrow
                                        placement="top"
                                        componentsProps={{
                                          tooltip: {
                                            sx: {
                                              fontSize: '16px', 
                                              backgroundColor: '#2f2f2f',
                                              color: '#fff',
                                              padding: '10px 14px',
                                              borderRadius: '8px',
                                              boxShadow: 3,
                                            },
                                          },
                                        }}
                                      >
                                        <div>
                                          <Checkbox
                                            id={`nominees[${index}].inCapacitation`}
                                            onChange={handleInCapacitationChange(index, setFieldValue, values)}
                                            checked={nominee.inCapacitation}
                                            disabled={values.nominees.some(n => n.inCapacitation) && !nominee.inCapacitation}
                                          />
                                        </div>
                                      </Tooltip>

                                      <span><strong>Incapacitation</strong></span>
                                    </div>

                                    <span style={{ fontSize: "0.875rem", color: "#555", marginLeft: "1rem", marginTop: "0.25rem" }}>
                                    (I hereby authorize this nominee to operate	my account on my behalf, in case of my incapacitation. He / She is authorized to encash my assets up to % of assets in the account / folio or Rs.)                                    
                                    </span>
                                  </div>
                                )}

                                {(nominee.inCapacitation && calculateAge(nominee.dob) > 18) && (
                                  <FormControl component="fieldset">
                                    <RadioGroup
                                      id={`nominees[${index}].inCapacitationAmountorPercentageCheck`}
                                      style={{ flexDirection: "row" }}
                                      value={nominee.inCapacitationAmountorPercentageCheck}
                                      onChange={(e) => {
                                        setFieldValue(`nominees[${index}].inCapacitationAmountorPercentageCheck`, e.target.value);
                                        setFieldValue(`nominees[${index}].inCapacitationAmount`, "");
                                      }}
                                    >
                                      <div className="investor-radio-button">
                                        <FormControlLabel
                                          value="Percentage"
                                          control={<Radio className="investor-search-radio" style={{ color: "#007ac8" }} />}
                                          label="Percentage"
                                        />
                                      </div>
                                      <div className="investor-radio-button">
                                        <FormControlLabel
                                          value="Amount"
                                          control={<Radio className="investor-search-radio" style={{ color: "#007ac8" }} />}
                                          label="Amount"
                                        />
                                      </div>
                                    </RadioGroup>
                                  </FormControl>
                                )}

                                {(nominee.inCapacitation && calculateAge(nominee.dob) > 18) && (
                                  <Input
                                    id={`nominees[${index}].inCapacitationAmount`}
                                    type="number"
                                    name={nominee.inCapacitationAmountorPercentageCheck}
                                    placeholder={`Enter ${nominee.inCapacitationAmountorPercentageCheck}`}
                                    value={nominee.inCapacitationAmount}
                                    onChange={(e) => {
                                      setFieldValue(`nominees[${index}].inCapacitationAmount`, e.target.value);
                                      validateField(`nominees[${index}].inCapacitationAmount`);

                                    }}
                                    onBlur={handleBlur}
                                    required
                                    isShowError={touched.nominees?.[index]?.inCapacitationAmount && !!errors.nominees?.[index]?.inCapacitationAmount}
                                    errorMessage={errors.nominees?.[index]?.inCapacitationAmount}
                                  />
                                )}

                              </div>
                            </div>
                          ))
                        }
                      </FieldArray>

                      <div className="d-flex align-items-center container-margin">
                        <button
                          className="new-investor-button new-investor-active rounded ml-auto text-uppercase m-0 mr-0"
                          style={{ filter: "grayscale(1) opacity(0.4)" }}
                          onClick={() => props.history.replace("/new-investor-transaction/fatca-details", state)}
                        >
                          BACK
                        </button>
                        <button className="new-investor-button new-investor-active" type="submit">
                          Save & Proceed
                        </button>
                      </div>
                    </Form>
                  )}
                </Formik>
              </div>
            </div>
          )}

        </CardComponent>
      ) : (
        <div style={{ display: "flex", justifyContent: "center" }}>
          {props.store_pan.charAt(3) === "H" &&
            props.applicantparams.typeofinvestor === "M"
            ? "Nominee section is disabled for HUF Investor"
            : "For minor's nominee section is disabled"}
        </div>
      )}
      {(!!nominateYesOrNo || props.store_pan.charAt(3) === "H" || props.applicantparams.typeofinvestor === "M") && (
        <div className="d-flex align-items-center container-margin">
          <button
            className="new-investor-button new-investor-active rounded ml-auto text-uppercase m-0 mr-0"
            style={{ filter: "grayscale(1) opacity(0.4)" }}
            onClick={() =>
              props.history.replace(
                "/new-investor-transaction/fatca-details",
                state
              )
            }
          >
            BACK
          </button>
          <button className="new-investor-button new-investor-active" onClick={Proceed}>
            Proceed
          </button>

        </div>
      )}
    </>
  );
};

export default connect(
  ({ authReducer, newinvestor }) => {
    const {
      applicantparams,
      fatcaDetails,
      getnomineeDetails,
      nomineDetails,
      address,
      store_pan,
      cart,
    } = newinvestor;
    const { userId } = authReducer
    return {
      fatcaDetails,
      applicantparams,
      getnomineeDetails,
      nomineDetails,
      address,
      store_pan,
      cart,
      userId
    };
  },
  {
    getCountriesList,
    getStatesList,
    storeApplicantParams,
    getKycDetails,
    checkKyc,
    getCitiesByState,
    getRelationShipList,
    storeNomineeDetails,
    getNomineeDetails,
  }
)(NomineeForm);


const addNewNominee = {
  Nom1: "ADD New Nominee",
  Nom1Relation: "son",
  Nom1_Gender: "",
  Nom1_Dob: "",
  Nom1_Add1: "",
  Nom1_Add2: "",
  Nom1_Add3: "",
  Nom1_City: "",
  Nom1_state: "",
  Nom1_pin: "",
  Nom1_Country: "",
  Nom1_GuardianName: "",
  NomPer1: "100",
};


export function isMajor(dob) {
  if (!dob || dob == "Invalid Date") return true;
  const age = differenceInYears(new Date(), new Date(dob));
  return age >= 18;
}

const normalizeIdType = (rawIdType) => {
  const mapping = {
    "AADHAR": "Aadhar",
    "PAN": "PAN",
    "DRIVING LICENSE": "Driving License",
    "PASSPORT": "Passport"
  };

  return mapping[rawIdType?.trim().toUpperCase()] || rawIdType;
};


